<template>
  <section
    :class="{
      multi: parts.length > 1,
      underline: underline,
      'no-indentation': noIndentation
    }"
  >
    <AccentHeader v-if="header" :underline="underline" :header="header" :uppercase="uppercase"/>
    <SwipeHandler @swipeLeft="swipeLeft" @swipeRight="swipeRight" class="parts-wrapper" v-if="parts.length">
      <p
        v-for="(part, index) in parts"
        :key="'part'+index"
        class="slide text-m paragraph"
        :class="{
          prev: index == activeItem - 1,
          active: index == activeItem,
          next: index == activeItem + 1,
          italic: italic
        }"
      >
        <span v-accent="part"></span>
        <span class="caption text-xs" v-if="caption && (parts.length === index + 1 || parts.length === 1)" v-accent="caption"></span>
      </p>
      <div class="controllers" v-if="parts.length !== 1">
        <button class="button-show" aria-label="show"
                :class="{ active: activeItem === index }"
                v-for="(part, index) in parts"
                :key="index"
                @click="setActive(index)">
          <svg height="12" width="12">
            <use class="is-active" xlink:href="#tringleAccentSvg"></use>
            <use class="is-active use-contrast" xlink:href="#tringleContrastSvg"></use>
            <use class="is-not-active" xlink:href="#tringleDarkSvg"></use>
            <use class="is-not-active on-dark" xlink:href="#tringleSvg"></use>
          </svg>
        </button>
      </div>
    </SwipeHandler>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import AccentHeader from '@/components/AccentHeader.vue'
import SwipeHandler from '@/components/SwipeHandler.vue'

export default {
  name: 'textSection',
  props: {
    header: String,
    description: String,
    caption: String,
    smaller: Boolean,
    underline: Boolean,
    uppercase: Boolean,
    italic: Boolean,
    noIndentation: Boolean,
    cutLength: {
      type: Number,
      default: 280
    },
    cutLengthTextBig: {
      type: Number,
      default: 170
    }
  },
  components: {
    AccentHeader,
    SwipeHandler
  },
  data: function () {
    return {
      activeItem: 0,
      partQty: 0
    }
  },
  computed: {
    ...mapGetters([
      'fontSize'
    ]),
    parts () {
      if (this.description) {
        let partArray = []
        let manualBreak = this.description.split('<wbr>')
        if (manualBreak.length > 1) {
          partArray = [...manualBreak]
        } else {
          // let textLength = this.description.length + 1
          let fullText = this.replaceConjunctions(this.description) + ' '
          // if (this.caption && this.caption.length) {
          //   textLength += this.caption.length
          // }
          let partCutLength = this.cutLength
          if (this.fontSize === 1) {
            partCutLength = this.cutLengthTextBig
          }
          // let partQty = Math.ceil(textLength / partCutLength)
          // let partLenght = Math.ceil(textLength / partQty)
          let partLenght = partCutLength
          let currentStop = 0
          let text = fullText.slice(currentStop)
          while (text.length > 0) {
            let toNextSpace = fullText.slice(partLenght).indexOf(' ')
            toNextSpace = toNextSpace !== -1 ? toNextSpace : 0
            let currentPart = text.substr(0, partLenght + toNextSpace + 1)
            currentPart = currentPart.lastIndexOf(' ') !== -1
              ? currentPart.substr(0, Math.min(currentPart.length, currentPart.lastIndexOf(' ')))
              : currentPart.substr(0, currentPart.length)
            currentStop += currentPart.length + 1
            text = fullText.slice(currentStop)
            partArray.push(currentPart)
          }
        }
        return [...partArray]
      } else {
        return []
      }
    }
  },
  methods: {
    swipeLeft () {
      this.activeItem = this.activeItem + 1 < this.parts.length
        ? Math.min(this.activeItem + 1, this.parts.length - 1)
        : 0
    },
    swipeRight () {
      this.activeItem = this.activeItem - 1 >= 0
        ? Math.max(this.activeItem - 1, 0)
        : this.parts.length - 1
    },
    setActive (index) {
      let difference = Math.abs(this.activeItem - index)
      if (difference) {
        if (difference !== 1) {
          this.activeItem += this.activeItem - index > 0 ? -1 : 1
          setTimeout(() => {
            this.setActive(index)
          }, 300)
        } else {
          this.activeItem = index
        }
      }
    },
    replaceConjunctions (text) {
      if (text) {
        let lettersToReplace = ['a', 'i', 'o', 'u', 'w', 'z', 'A', 'I', 'O', 'U', 'W', 'Z', 'and', 'or']
        let arrayLength = lettersToReplace.length
        for (let i = 0; i < arrayLength; i++) {
          let textSplit = text.split(' ' + lettersToReplace[i] + ' ')
          text = textSplit.join(' ' + lettersToReplace[i] + '&nbsp;')
        }
        return text
      } else {
        return ''
      }
    }
  },
  watch: {
    fontSize: function (val) {
      if (val === 0) {
        this.activeItem = 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
  h2 {
    padding: 0;
    margin: 0 0 25px 0;
    letter-spacing: 0;
    max-width: 460px;
    font-weight: 600;
    hyphens: none;
    white-space: pre-line;
    word-wrap: break-word;

    &.underline {
      padding: 0 0 $gap-md 0;
    }

    @include mobile {
      max-width: 100%;
    }
  }
  .italic {
    font-style: italic;
    .caption {
      font-style: normal;
    }
  }
  p {
    @include tablet {
      padding-right: 1em;
    }
  }

  .parts-wrapper {
    margin: 35px 0 50px 100px;
    position: relative;
    width: 350px;
    min-height: 100px;
    text-align: left;
    padding: 0;
    @include desktop {
      margin: 35px 0 30px 50px;
    }
    @include mobile {
      margin: 40px 0 50px 0;
      width: 100%;
    }
    .no-indentation &,
    .underline & {
      margin: 35px 0 50px 0px;
      @include desktop {
        margin: 35px 0 30px 0;
      }
    }
    /deep/ a {
      color: $text-accent;
      text-decoration: none;
    }
  }
  .caption {
    display: block;
    margin-top: 15px;
    font-weight: 500;
  }
  .button-show {
    border: 0;
    background-color: transparent;
    font-size: 0;
    color: transparent;
    box-shadow: none;
    padding: 5px;
    width: 24px;
    height: 32px;
    &:focus {
      outline: none;
    }
    svg {
      display: block;
      height: 12px;
      width: 12px;
    }
    .font-size-l & {
      height: 48px;
      width: 32px;
      svg {
        height: 24px;
        width: 24px;
      }
    }
    .is-active {
      display: none;
    }
    .on-dark {
      display: none;
    }
    .dark & {
      .is-not-active {
        display: none;
      }
      .on-dark {
        display: block;
      }
    }
    &.active {
      .is-active {
        display: block;
      }
      .is-not-active {
        display: none;
      }
    }
  }

  .controllers {
    position: absolute;
    z-index: 30;
    bottom: 0;
    left: -5px;
  }
  .multi {
    .parts-wrapper {
      margin: 35px 0 30px 100px;
      padding: 0 0 50px 0;
      min-height: 210px;
      overflow: hidden;
      @include desktop {
        margin: 35px 0 30px 50px;
      }
      @include tablet {
        min-height: 230px;
        margin: 55px 0 40px 0;
      }
      @include mobile {
        min-height: 245px;
        margin: 55px 0 40px 0;
      }
      @include mobile-small {
        min-height: 320px;
      }
    }
    &.no-indentation,
    &.underline {
      .parts-wrapper {
        margin: 35px 0 50px 0px;
        @include desktop {
          margin: 35px 0 30px 0;
        }
      }
    }
    .slide {
      display: none;
      overflow: hidden;
      opacity: 0;
      padding: 0;
      position: relative;
      transition: $transitionSlider;
      text-align: left;
      width: 0;
      z-index: 1;

      &.prev,
      &.next,
      &.active {
        display: block;
        width: 100%;
      }
      &.prev,
      &.next {
        height: 100%;
        opacity: 0.3;
        position: absolute;
        top: 0;
      }
      &.prev {
        left: 0;
        transform: translateX(-100vw);
      }
      &.next {
        left: auto;
        right: 0;
        transform: translateX(100vw);
      }
      &.active {
        transform: translateX(0);
        opacity: 1;
      }
    }
  }
</style>
